import { UnknownAction } from "@reduxjs/toolkit";
import localForage from "localforage";
import { PersistConfig, persistCombineReducers } from "redux-persist";
// Common Reducers
import {
    RESET_STORE,
    coreReducers,
    resetFinancingData,
    sanitizeCheckoutData,
    sanitizeCommonData,
} from "tsi-common-react/src/store/reducers";

import { IReduxState } from "./reducers.interfaces";

const storage = localForage.createInstance({
    name: "cocoon-redux",
});
const persistConfig: PersistConfig<IReduxState> = {
    key: "redux-global",
    storage: storage,
    transforms: [sanitizeCommonData, sanitizeCheckoutData, resetFinancingData],
    whitelist: ["common", "checkout", "financing", "retail"],
};
const _innerReducers = persistCombineReducers<IReduxState, UnknownAction>(
    persistConfig,
    {
        ...coreReducers,
    },
);

/**
 * Root reducer with support for full store reset.
 * When RESET_STORE is dispatched, all slices return to their initial state.
 */
export const reducers: typeof _innerReducers = (state, action) => {
    if (action.type === RESET_STORE) {
        return _innerReducers(undefined, action);
    }
    return _innerReducers(state, action);
};
